import classes from 'classnames';
import { Topic, UnitAssets } from '@/types/units';
import classNames from './TopicInfo.module.scss';
import { useAppSelector } from '@/store';
import UseUnitsAssets from '@/hooks/UseUnitsAssets';

import QuizBadge from '@/components/QuizBadge/QuizBadge';
import trophy from '@/assets/svg/trophy.svg';
import lock from '@/assets/svg/lock.svg';
import React from 'react';
import { unitSelector } from '@/store/reducers/unit';
import AccessibleButton from '@/components/AccessibleButton/AccessibleButton';

interface TopicInfoProps {
  className?: string;
  isLocked: boolean;
  isComplete: boolean;
  topic: Topic;
  index: number;
  unitId: number;
  emitOpenModal: (topicId: number) => void;
}

const TopicInfo = ({
  className,
  isLocked,
  isComplete,
  topic,
  index,
  emitOpenModal,
}: TopicInfoProps) => {
  const { selectedUnit } = useAppSelector(unitSelector);
  const { unitsAssets } = UseUnitsAssets();

  const unitAssets: UnitAssets = unitsAssets[selectedUnit?.order || 1];
  const setStatusSrc = () => {
    if (!isLocked) {
      return isComplete ? trophy : unitAssets?.medal;
    }

    return lock;
  };

  const handleOpenTopic = () => {
    if (isLocked) {
      return;
    }

    emitOpenModal(topic.id);
  };

  return (
    <AccessibleButton
      className={classes(
        classNames.topicInfo,
        { [classNames.topicInfoLocked]: isLocked },
        className
      )}
      onClick={handleOpenTopic}
      disabled={isLocked}
    >
      <QuizBadge
        img={setStatusSrc() ?? ''}
        isComplete={isComplete}
        isLocked={isLocked}
        isEndOfSkillTest={false}
        index={index}
      />
      <span className={classNames.title}>
        {topic.name && topic.name.includes(' ') && false
          ? topic.name.split(' ').map((word, index) => (
              <React.Fragment key={index}>
                {word}
                <br />
              </React.Fragment>
            ))
          : topic.name}
      </span>
    </AccessibleButton>
  );
};

export default TopicInfo;
